<template>
  <v-app app>
    <comp-navigation v-if="isPublicPath"> </comp-navigation>

    <v-main>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>

  </v-app>
</template>

<script>
//import Footer from "./components/shared/Footer.vue";
import NavBar from "./components/shared/NavBar.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    //"comp-footer": Footer,
    "comp-navigation": NavBar,
  },

  computed: {
    ...mapState("auth", ["isLoggedIn"]),
    isPublicPath() {
      return this.$route.meta.requiresAuth;
    },
  },

  methods: {
    ...mapActions("base", ["getPlanList"]),
    ...mapActions("theme", ["getThemeList"]),
    ...mapActions("specialty", ["getSpecialtyList"]),
    ...mapActions("profile", ["getProfileList"]),
  },

  data() {
    return {};
  },

  created() {
    if (this.isLoggedIn) {
      this.getProfileList();
      this.getPlanList();
      this.getThemeList();
      this.getSpecialtyList();
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
